export const FACTORY_OPTIONS_TYPES = {
  FACTORY_FIT: 'Factory fit',
  STANDARD: 'Standard'
}

export const WARRANTY_TYPES = {
  EXTENDED: 'Extended',
  STANDARD: 'Standard'
}

export enum BulkActionsSources {
  QUOTES = 'quotes',
  EQUIPMENTS = 'equipments'
}
